import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../assets/images/gainservo-logo.png';

const PageNotFound = () => {
  return (
    <div className='min-h-screen bg-gradient-to-br from-green-200 via-white to-blue-200 flex flex-col items-center justify-center px-4'>
      <div className='text-center max-w-2xl mx-auto'>
        {/* Logo */}
        <div className='mb-8'>
          <img className='h-20 w-auto mx-auto mb-6' src={Image} alt="Gainservo" />
        </div>

        {/* 404 İkonu */}
        <div className='mb-8'>
          <div className='text-8xl md:text-9xl font-bold text-[#2E3192] mb-4'>
            404
          </div>
        </div>

        {/* Hata Mesajı */}
        <h1 className='text-3xl md:text-4xl font-bold text-[#2E3192] mb-4'>
          Sayfa Bulunamadı
        </h1>
        <p className='text-lg text-gray-600 mb-8'>
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>

        {/* Ana Sayfaya Dön Butonu */}
        <Link 
          to="/" 
          className='inline-flex items-center px-6 py-3 bg-[#2E3192] hover:bg-[#CCDC59] text-white hover:text-[#2E3192] font-semibold rounded-lg transition duration-300 shadow-lg hover:shadow-xl'
        >
          <svg className='w-5 h-5 mr-2' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' />
          </svg>
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
